import { createAction } from '@reduxjs/toolkit';

export const moreGamesCleanUp = createAction('moreGamesCleanUp');

export const moreGamesUpdate = createAction('moreGamesUpdate');
